import {AxiosResponse, CancelToken} from "axios";
import {axiosInstance} from "./AxiosInstance";
import {
    BEARER,
    ROUTE_GET_SURVEY, ROUTE_GET_SURVEY2, ROUTE_GET_SURVEYS, ROUTE_POST_LOGIN, ROUTE_POST_LOGOUT,
    ROUTE_POST_SURVEY, ROUTE_POST_USERDATA,
} from "../constants";
import {ISurvey} from "../interfaces/ISurvey";
import {IUserResponseDto} from "../interfaces/IUserResponseDto";
import {ISaveResponseStatus} from "../interfaces/ISaveResponseStatus";
import {ILoginRequest} from "../interfaces/ILoginRequest";
import {ISurveyUserData} from "../interfaces/ISurveyUserData";


export function SurveyApi() {

    /**
     * POST method for getting user data
     * @param {string} request - request data
     * @param {CancelToken} ct - cancellation token
     * @return {Promise<AxiosResponse<ISurveyUserData, any>>} response with user data
     */
    const getUserData = async (request: string, ct: CancelToken): Promise<AxiosResponse<ISurveyUserData, any>> => {
        return await axiosInstance.post<ISurveyUserData>(
            process.env.REACT_APP_BASE_ROUTE + ROUTE_POST_USERDATA,
            JSON.stringify(request),
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                cancelToken: ct
            }
        );
    };

    /**
     * POST method for login
     * @param {ILoginRequest} request - request data
     * @param {CancelToken} ct - cancellation token
     * @return {Promise<AxiosResponse<any, any>>} response with status code
     */
    const login = async (request: ILoginRequest, ct: CancelToken): Promise<AxiosResponse<any, any>> => {
        return await axiosInstance.post<string>(
            process.env.REACT_APP_BASE_ROUTE + ROUTE_POST_LOGIN,
            request,
            {
                cancelToken: ct
            }
        );
    };

    /**
     * POST method for logout
     * @param {CancelToken} ct - cancellation token
     * @return {Promise<AxiosResponse<string, any>>} response with api key
     */
    const logout = async (ct: CancelToken): Promise<AxiosResponse<string, any>> => {
        return await axiosInstance.post<string>(
            process.env.REACT_APP_BASE_ROUTE + ROUTE_POST_LOGOUT,
            null,
            {
                cancelToken: ct
            }
        );
    };

    /**
     * GET method for obtaining survey details
     * @param {string} id - survey id
     * @param {CancelToken} ct - cancellation token
     * @return {Promise<AxiosResponse<ISurvey, any>>} response with survey details
     */
    const getSurvey = async (id: string, ct: CancelToken): Promise<AxiosResponse<ISurvey, any>> => {
        return await axiosInstance.get<ISurvey>(
            process.env.REACT_APP_BASE_ROUTE + ROUTE_GET_SURVEY,
            {
                params: {
                    id: id
                },
                cancelToken: ct
            }
        );
    };

    /**
     * GET method for obtaining survey details
     * @param {string} id - survey id
     * @param {CancelToken} ct - cancellation token
     * @return {Promise<AxiosResponse<ISurvey, any>>} response with survey details
     */
    const getSurvey2 = async (id: string, ct: CancelToken): Promise<AxiosResponse<ISurvey, any>> => {
        return await axiosInstance.get<ISurvey>(
            process.env.REACT_APP_BASE_ROUTE + ROUTE_GET_SURVEY2,
            {
                params: {
                    id: id
                },
                cancelToken: ct
            }
        );
    };

    /**
     * POST method for submitting the survey
     * @param {IUserResponseDto} request - request data
     * @param {CancelToken} ct - cancellation token
     * @return {Promise<AxiosResponse<ISaveResponseStatus, any>>} response with submitting status
     */
    const postSurvey = async (request: IUserResponseDto, ct: CancelToken): Promise<AxiosResponse<ISaveResponseStatus, any>> => {
        return await axiosInstance.post<ISaveResponseStatus>(
            process.env.REACT_APP_BASE_ROUTE + ROUTE_POST_SURVEY,
            request,
            {
                params: { },
                cancelToken: ct
            }
        );
    };

    /**
     * GET method for obtaining list of survey details
     * @param {CancelToken} ct - cancellation token
     * @return {Promise<AxiosResponse<ISurvey[], any>>} response with list of survey details
     */
    const getSurveys = async (ct: CancelToken): Promise<AxiosResponse<ISurvey[], any>> => {
        return await axiosInstance.get<ISurvey[]>(
            process.env.REACT_APP_BASE_ROUTE + ROUTE_GET_SURVEYS,
            {
                cancelToken: ct
            }
        );
    };

    return {
        getUserData,
        login,
        logout,
        getSurvey,
        getSurvey2,
        postSurvey,
        getSurveys
    };
}